import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Classic%20Hong%20Kong%20cinema%20atmosphere%20with%20vintage%20film%20projector%20casting%20warm%20golden%20light%20through%20dust%20particles%2C%20old%20movie%20theater%20interior%20with%20red%20velvet%20seats%2C%20nostalgic%2035mm%20film%20strips%20hanging%2C%20amber%20and%20gold%20cinematic%20tones%2C%20dramatic%20lighting%20with%20deep%20shadows%2C%20artistic%20composition&width=1600&height=900&seq=hero-hk-cinema-main&orientation=landscape"
          alt="香港电影影史回顾"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>
      <div className="absolute inset-0 flex items-center justify-center">
        <div className="text-center px-4 w-full max-w-4xl">
          <p className="text-primary-300 text-sm md:text-base font-medium tracking-widest mb-4 uppercase">
            香港电影影史专业参考
          </p>
          <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight">
            香港三级片影史
            <br />
            <span className="text-primary-300">全解析与文化回顾</span>
          </h1>
          <p className="text-white/70 text-base md:text-lg max-w-2xl mx-auto mb-8 leading-relaxed">
            系统梳理香港电影分级制度的演变历程，深度解读经典三级片作品，
            从影史研究视角探讨香港情色电影在华语影坛的独特地位与文化价值。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/category/huangjin-shidai"
              className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium rounded-lg transition-colors duration-200 whitespace-nowrap cursor-pointer text-sm"
            >
              <i className="ri-time-line"></i>
              探索黄金时代
            </Link>
            <Link
              to="/category/jingdian-tuijian"
              className="inline-flex items-center gap-2 px-6 py-3 bg-white/15 hover:bg-white/25 text-white font-medium rounded-lg transition-colors duration-200 whitespace-nowrap cursor-pointer text-sm backdrop-blur-sm"
            >
              <i className="ri-movie-line"></i>
              经典影片推荐
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}